// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kZr_","icon":"styles_icon__3zULD"};